import React from 'react'
import { Grid, Typography, Box, makeStyles, Link } from '@material-ui/core'
import { Lock, AccountBalance } from '@material-ui/icons'
import useCurrentUserProp from 'hooks/useCurrentUserProp'
import WithdrawalAccount from 'components/WithdrawalAccount'
import { InfoOutlined } from '@material-ui/icons'

const useStyles = makeStyles(({ palette: { text: { secondary } } }) => ({
  icon: {
    fontSize: '3rem',
    color: secondary
  }
}))

export default function SetupFundingAccount({ completeStep, Footer }) {
  const classes = useStyles()
  const userHasWithdrawalAccount = useCurrentUserProp('withdrawalAccount')

  return (
    <React.Fragment>
      <Grid container justifyContent='center'>
        <Grid item xs={12} sm={8} md={6} lg={4}>
          <Box textAlign='center' mb={4}>
            <Typography gutterBottom variant='h4' component='h1'>Setup Funding Account</Typography>
            <Lock className={classes.icon} />
            <AccountBalance className={classes.icon} />
          </Box>

          <div>
            <Typography align='center' variant='body2' paragraph>
              {userHasWithdrawalAccount ? (
                'Great! Your bank account has been connected and you can now contribute tithes and roundups from it.'
              ) : (
                'Now we need to connect your bank account through Plaid. All donations you make will be deducted from this account. It must be a debit bank account.'
              )}
            </Typography>
            <WithdrawalAccount />
          </div>

          <div>
            <Typography align='center' variant='body2' gutterBottom>
              This process is fully secured by Plaid with 256-bit bank-level encryption.<br/>
              <Link variant='body2' rel='noopener noreferrer' target='_blank' href='https://plaid.com/what-is-plaid/'>
                Learn more here
                <sup><InfoOutlined fontSize='inherit' /></sup>
              </Link>
            </Typography>
          </div>
        </Grid>
      </Grid>
      <Footer handleClickNext={() => completeStep('Setup Funding Account')} disableNextButton={!userHasWithdrawalAccount} />
    </React.Fragment>
  )
}
